import React from "react";
import { useParams } from "react-router-dom";
import MigrationManagement from "./MigrationManagement";

const OrganizationMigrationPage = () => {
  const { organizationId } = useParams();

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Data Migration</h1>
        <p className="text-muted-foreground">
          Manage data migration and import/export for this organization
        </p>
      </div>
      <MigrationManagement organizationId={organizationId} />
    </div>
  );
};

export default OrganizationMigrationPage;
